







































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Collection, ID, Resp} from 'simpli-web-sdk'
import Carga from '@/model/resource/Carga'
import * as Helper from '@/helpers'
import CargaRequest from '@/model/request/CargaRequest'
import { DeliveryStatus } from '@/enums/DeliveryStatus'
const sha1 = require('sha1')

@Component
export default class ModalDeliveryRemove extends Vue {

  collection = new Collection(Carga)

  senha = null
  justificativa = null

  mostrarSenhaEJustificativa = false
  DeliveryStatus = DeliveryStatus

  async remove() {
    const ids = this.collection.items.map((item) => item.$id)

    const request = new CargaRequest()
    request.ids = ids

    if (this.mostrarSenhaEJustificativa) {
      request.senhaExcluirNotas = this.senha ? sha1(this.senha) : null
      request.justificativaExcluirNotas = this.justificativa
      request.validarExcluirNota = true
    }

    await Carga.removerCargaEmLote(request as CargaRequest, 'cargaInProgress')
    Helper.success('system.success.remove')
    this.$emit('remove')
    this.close()
  }

  close() {
    this.$modal.close('deliveryRemove')
  }

  async openEvent(selectedItems: Carga[]) {
    this.$emit('open')
    this.collection.items = selectedItems
    this.mostrarSenhaEJustificativa =
        selectedItems.some((it) => {
              // @ts-ignore
              const status = it.status || it.statusCarga
              return !!status &&
                  (
                      (status.idStatusPk === DeliveryStatus.FINISHED) ||
                      (status.idStatusPk === DeliveryStatus.STARTED)
                  )
            },
        )
  }

  closeEvent() {
    this.$emit('close')
    this.collection.items = []
    this.mostrarSenhaEJustificativa = false
    this.senha = null
    this.justificativa = null
  }

}
